import React from "react";
import {useTranslation} from "react-i18next";
import {SelectField} from "./CourierRequestPrioritySelect.style";
import {courierRequestPriorities, courierRequestPriorityRankIconKeys} from "constants/constants";
import {RankIcon} from "components/_defaultComponents/RankIcon/RankIcon";

export const CourierRequestPrioritySelect = ({
    value,
    onChange,
    disabled = false,
    mode = undefined,
    allowClear = false,
    showSearch = true,
    showTitle = true,
    showAllOption = false,
    marginBottom = "20px",
    placeholder = "",
    optionFilter = () => true,
    initialCall = true,
    ...props
}) => {
    const {t} = useTranslation();

    return (
        <React.Fragment>
            {showTitle && <h5>{t("Öncelik")}</h5>}
            <SelectField
                data-testid="zoneSubcompaniesSelect"
                value={value}
                onChange={onChange}
                disabled={disabled}
                mode={mode}
                allowClear={allowClear}
                showSearch={showSearch}
                placeholder={placeholder || t("Öncelik seçiniz")}
                filterOption={(input, option) => {
                    return (
                        option?.["data-priorityname"]
                            ?.toLocaleLowerCase("TR-tr")
                            ?.indexOf(input.toLocaleLowerCase("TR-tr")) >= 0
                    );
                }}
                mb={marginBottom}
                {...props}
            >
                {showAllOption && (
                    <SelectField.Option value="all" data-testid="zoneSubcompaniesSelect_all_option">
                        {t("filters.all", {ns: "common"})}
                    </SelectField.Option>
                )}
                {courierRequestPriorities &&
                    courierRequestPriorities.length > 0 &&
                    courierRequestPriorities.filter(optionFilter).map(courierRequestPriority => (
                        <SelectField.Option
                            key={courierRequestPriority.value}
                            value={courierRequestPriority.value}
                            data-testid="courierRequestPrioritySelect_option"
                            style={{borderBottom: "1px solid #e0e0e0"}}
                            data-priorityname={courierRequestPriority.name}
                        >
                            <div style={{display: "flex", alignItems: "center", gap: 4}}>
                                <RankIcon
                                    rankType={
                                        courierRequestPriorityRankIconKeys?.[
                                            courierRequestPriority.value
                                        ]
                                    }
                                />
                                {courierRequestPriority.name}
                            </div>
                        </SelectField.Option>
                    ))}
            </SelectField>
        </React.Fragment>
    );
};
